import React, { Component } from "react";
import { connect } from "react-redux";
import { BlueBtn } from "components/Controls";
import {
  loadingSelector,
  activeStepDataSelector,
  appRequestSelector,
  prequalDataSelector,
} from "containers/MultistepForm/selectors";
import {backToOffers, selectOffer} from 'containers/MultistepForm/actions';

import { selectedOfferSelector } from "../../../selectors";

import "./styles.scss";
import ProgressiveLogo from "../../../../../assets/img/progressive-logo.png";
import { logEvent } from "../../../../EmbeddableWidget/actions";
import { addThousandsSeparator } from "../../../../../utils/helpers";

class ApprovedAppScreen extends Component {
  state = {
    loadingLease: false,
  };

  handleBackButton = () => {
    const { backToOffers, logEvent } = this.props;
    backToOffers();
    logEvent({ name: "view other options" });
  };

  submit = () => {
    const { offer, appRequest, prequalData } = this.props;
    this.setState({loadingLease: true});

    const payload = { offer };
    if (prequalData) {
      payload.body = {
        items: appRequest.items,
        orderId: appRequest.orderId,
        shipping: appRequest.shipping,
      };
    }
    this.props.selectOffer(payload);
  };

  render() {
    const { loading, offer } = this.props;
    const { loadingLease} = this.state;

    const approvedAmount = `$${addThousandsSeparator(offer.approval_amount)}`;
    const cartTotal = offer.cart_total ? `$${addThousandsSeparator(offer.cart_total)}` : null;
    const filteredPricing = offer?.pricing_estimate?.termMonthEstimates.filter(item => [12, 3, 6].includes(item.paymentMonth));
    return (
      <div className="expanded-block-component bank-data-form-container">
        <div className="bank-data-form-header">
          <img src={ProgressiveLogo} alt="Progressive Logo"/>
          <h1>Congrats, You're Approved</h1>
          <p>
            {`You've been approved to lease items up to ${approvedAmount} in
            cash price with Progressive Leasing.`}
          </p>

          <div className="approval-amount">
            <p className="font-bold">
              Approval Amount{' '}
              <span className="font-bold">{approvedAmount}</span>
            </p>
            {offer.lease_id && <p>{`Lease ID: ${offer.lease_id}`}</p>}
          </div>
          <p className="disclosure font-italic">
            The standard lease-to-own agreement offers 12 months to ownership and could cost more than double the cash
            price.
          </p>

          <div className="overview">
            <p className="font-bold">Overview of Your Purchase</p>
            <p>
              How often you’re paid and your cart subtotal make up your payment
              schedule. You’ll automatically be set up for a 12-month lease.
            </p>
            {cartTotal &&
              <p className="gray-highlight">
                Cart subtotal <span>{cartTotal}</span>
              </p>
            }
          </div>

          <div className="lease-to-own active">
            <p className="font-bold">12-month standard lease-to-own</p>
            <p>
              Bi-weekly payments*{' '}
              <span>{`$${addThousandsSeparator(
                filteredPricing?.[2].paymentAmount
              )}`}</span>
            </p>
            <p className="font-bold">
              Lease-to-own total cost*{' '}
              <span>{`$${addThousandsSeparator(
                filteredPricing?.[2].cumulativeAmountPaid
              )}`}</span>
            </p>
          </div>

          <div className="overview">
            <p className="font-bold">The earlier you pay, the more you save</p>
            <p>
              After you receive your items, login to your account or call Progressive Leasing at (877)
              898-1970 to set up an early purchase option.
            </p>
          </div>
          <div className="lease-to-own inactive">
            <p className="font-bold">90 Day (3 months in CA) Early Purchase Option**</p>
            <p>
              Bi-weekly payments*{' '}
              <span>{`$${addThousandsSeparator(
                filteredPricing?.[0].paymentAmount
              )}`}</span>
            </p>
            <p className="font-bold">
              Lease-to-own total cost*{' '}
              <span>{`$${addThousandsSeparator(
                filteredPricing?.[0].cumulativeAmountPaid
              )}`}</span>
            </p>
          </div>
          <p className="font-italic">
            **Standard agreement offers 12 months to ownership. 90-day and other early purchase options cost more than
            the
            retailer’s cash price (except 3-month option in CA). To purchase early, or to cancel lease and schedule
            return
            of merchandise, you must call 877-898-1970. Retailer cannot activate early purchase options.
          </p>
          <p className="font-italic">
            *Applicable taxes will be added to all payments and collected by
            Progressive Leasing.
          </p>
        </div>

        <div className="footer">
          <BlueBtn loading={loading || loadingLease} onClick={this.submit}>
            Sign Lease & Place Order
          </BlueBtn>
          <BlueBtn customClass="outlined-btn" onClick={this.handleBackButton}>
            Back
          </BlueBtn>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: loadingSelector()(state),
  offer: activeStepDataSelector()(state),
  selectedOffer: selectedOfferSelector()(state),
  appRequest: appRequestSelector()(state),
  prequalData: prequalDataSelector()(state),
});

const mapDistpatchToProps = (dispatch) => {
  return {
    backToOffers: () => dispatch(backToOffers()),
    logEvent: (value) => dispatch(logEvent(value)),
    selectOffer: (data) => dispatch(selectOffer(data)),
  };
};

ApprovedAppScreen = connect(
  mapStateToProps,
  mapDistpatchToProps
)(ApprovedAppScreen);

export default ApprovedAppScreen;
